import React, { useState } from 'react';
import Select from '../atoms/Select';
import Tag from '../atoms/Tag';
import FieldLabel from '../atoms/FieldLabel';

/**
 * Multi-select via dropdown + removable tags.
 */
export default function RoleMultiSelect({
  label = 'Select Roles',
  options = [],
  value = [],
  onChange,
  placeholder = 'Select roles',
  className = '',
}) {
  const [openValue, setOpenValue] = useState('');

  const available = options.filter((opt) => {
    const val = typeof opt === 'string' ? opt : opt.value;
    return !value.includes(val);
  });

  const handleSelect = (e) => {
    const next = e.target.value;
    if (!next) return;
    onChange?.([...value, next]);
    setOpenValue('');
  };

  const handleRemove = (role) => {
    onChange?.(value.filter((r) => r !== role));
  };

  return (
    <div className={`ca-role-select ${className}`.trim()}>
      <FieldLabel>{label}</FieldLabel>
      <Select
        value={openValue}
        onChange={handleSelect}
        options={available}
        placeholder={placeholder}
      />
      {value.length > 0 ? (
        <div className="ca-tag-list">
          {value.map((role) => (
            <Tag key={role} label={role} onRemove={() => handleRemove(role)} />
          ))}
        </div>
      ) : null}
    </div>
  );
}
